import { Component, Input } from '@angular/core';

@Component({
  selector: 'progress-bar',
  template: require('./progress-bar.html'),
  styles: [require('./progress-bar.scss')],
})
export class ProgressBarComponent {

  @Input() progress: string;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/progress-bar/progress-bar.component.ts